import React from 'react';
import styled from 'styled-components';
import { Label, ColorOption, ColorPickerContainer } from './StyledComponents';
import ColorPicker from '../ColorPicker';

const AudienceColors = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #dbdde0;
  border-radius: 8px;
  padding: 8px 16px 8px 16px;
`;

const ColorPickerWrapper = styled.div`
  width: 24px;
  height: 24px;
`;

const colorOptions = [
  '#ffb748',
  '#ff687b',
  '#b6a9f1',
  '#4fd4c0',
  '#42b2ee',
  '#40beff',
  '#8da0ab',
];

const renderColorOptions = (setColor, selected) =>
  colorOptions.map((background, index) => (
    <ColorOption
      key={index}
      className="color-option"
      background={background}
      isSelected={selected === background}
      onClick={e => setColor(background)}
    />
  ));

export const ColorsPicker = ({ color, resourceType, setColor }) => {
  const fieldName = `${resourceType}-color`;
  const fieldId = `${resourceType}_color`;

  return (
    <ColorPickerContainer>
      <Label>Select a color</Label>
      <AudienceColors className="audience-colors">
        {renderColorOptions(setColor, color)}
        <ColorPickerWrapper>
          <ColorPicker
            colorChangeHandler={color => {
              setColor(color);
            }}
          />
        </ColorPickerWrapper>
      </AudienceColors>
    </ColorPickerContainer>
  );
};

export default ColorsPicker;
